// French messages for Firebase Auth errors, plus FQST's own auth error codes.
import * as Sentry from "@sentry/react";

const BAD_CREDENTIALS = "Courriel ou mot de passe incorrect.";

const MESSAGES = {
  "auth/invalid-credential": BAD_CREDENTIALS,
  "auth/invalid-login-credentials": BAD_CREDENTIALS,
  "auth/wrong-password": BAD_CREDENTIALS,
  "auth/user-not-found": BAD_CREDENTIALS,
  "auth/invalid-email": "Adresse courriel invalide.",
  "auth/missing-email": "Veuillez entrer votre adresse courriel.",
  "auth/missing-password": "Veuillez entrer votre mot de passe.",
  "auth/email-already-in-use":
    "Un compte existe déjà avec cette adresse. Connectez-vous, ou utilisez « Mot de passe oublié ? ».",
  "auth/weak-password": "Le mot de passe doit contenir au moins 6 caractères.",
  "auth/too-many-requests":
    "Trop de tentatives. Patientez quelques minutes avant de réessayer.",
  "auth/network-request-failed":
    "Problème de connexion réseau. Vérifiez votre connexion et réessayez.",
  "auth/user-disabled": "Ce compte a été désactivé. Contactez la FQST.",
  "fqst/email-not-verified":
    "Votre adresse courriel n'est pas encore confirmée. Cliquez sur le lien reçu par courriel.",
  "fqst/invalid-phone":
    "Numéro de téléphone invalide. Exemple : 514 555-1234 ou +33 6 12 34 56 78.",
  "fqst/password-mismatch": "Les mots de passe ne correspondent pas.",
};

/** An Error carrying an auth code, so the pages can show the matching message. */
export const authError = (code) => {
  const error = new Error(MESSAGES[code] || code);
  error.code = code;
  return error;
};

export const authErrorMessage = (error) =>
  MESSAGES[error?.code] || "Une erreur inattendue est survenue. Réessayez.";

/**
 * Send unexpected errors to Sentry. Wrong passwords, typos and rate limits are
 * normal user behaviour and would only bury the real problems.
 */
export const reportAuthError = (error) => {
  if (!MESSAGES[error?.code]) Sentry.captureException(error);
};
